import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import Loader from "../child/Loder";
import SuccessAlert from "../child/Alert/SuccessAlert";
import DengerAlert from "../child/Alert/DengerAlert";
import { fetchPurchaseById } from "../services/PaymentsandTransactions";
import moment from "moment";

const ViewTransactionPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [transaction, setTransaction] = useState(null);
  const [loading, setLoading] = useState(true);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [activeTab, setActiveTab] = useState("transaction-info");


  const getTransactionDetails = async () => {
    try {
      const res = await fetchPurchaseById(id);
      setTransaction(res?.data?.data);
    } catch (error) {
      console.error(error);
      setErrorMessage("Failed to load transaction details");
      setTimeout(() => setErrorMessage(""), 3000);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getTransactionDetails();
    }
  }, [id]);

  if (loading) return <Loader />;

  return (
    <div className="row gy-4">
      <div className="col-md-12">
        <div className="card h-100">
          <div className="card-body p-24">

            {/* Alerts */}
            {successMessage && (
              <SuccessAlert
                message={successMessage}
                onClose={() => setSuccessMessage("")}
              />
            )}
            {errorMessage && (
              <DengerAlert
                message={errorMessage}
                onClose={() => setErrorMessage("")}
              />
            )}

            {/* Tabs */}
            <ul
              className="nav border-gradient-tab nav-pills mb-20 d-inline-flex"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link d-flex align-items-center px-24 ${activeTab === "transaction-info" ? "active" : ""
                    }`}
                  onClick={() => setActiveTab("transaction-info")}
                  type="button"
                  role="tab"
                >
                  Transaction Info
                </button>
              </li>
            </ul>
            <div className="tab-content">
              <div
                className={`tab-pane fade ${activeTab === "transaction-info" ? "show active" : ""
                  }`}
                role="tabpanel"
              >
                {/* Details Grid */}
                <div className="row">

                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">User Name:</label>
                    <div>{transaction?.user?.fullName || "N/A"}</div>
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">User Email:</label>
                    <div>{transaction?.user?.email || "N/A"}</div>
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">Product ID:</label>
                    <div>{transaction?.productId || "N/A"}</div>
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">Store Product ID:</label>
                    <div>{transaction?.storeProductId || "N/A"}</div>
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">Platform:</label>
                    <div>{transaction?.platform || "N/A"}</div>
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">Amount:</label>
                    <div>
                      {transaction?.amount}{" "}
                      {transaction?.currency?.toUpperCase()}
                    </div>
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">Status:</label>
                    <div>{transaction?.status || "N/A"}</div>
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">Purchase Date:</label>
                    <div>
                      {transaction?.createdAt
                        ? moment(transaction.createdAt).format("DD-MM-YYYY, hh:mm A")
                        : "N/A"}
                    </div>
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">Processed At:</label>
                    <div>
                      {transaction?.processedAt
                        ? moment(transaction.processedAt).format("DD-MM-YYYY, hh:mm A")
                        : "N/A"}
                    </div>
                  </div>

                  {/* Raw Response */}
                  {/* <div className="col-md-12 mb-3">
                    <label className="form-label fw-bold">Raw Response:</label>
                    <pre className="bg-light p-12 radius-8 mt-8">
                      {transaction?.rawResponse
                        ? JSON.stringify(transaction.rawResponse, null, 2)
                        : "N/A"}
                    </pre>
                  </div> */}

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewTransactionPage;
